export function Location() {
  const handleGetDirections = () => {
    window.open('https://maps.google.com/?q=123+Main+Street+Downtown', '_blank');
  };

  return (
    <section id="location" className="relative py-32 px-8 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://readdy.ai/api/search-image?query=beautiful%20downtown%20main%20street%20storefront%20neighborhood%20shopping%20district%20charming%20local%20business%20area%20tree%20lined%20street%20with%20shops%20warm%20afternoon%20light%20inviting%20commercial%20district%20small%20town%20atmosphere%20professional%20architectural%20photography&width=1920&height=800&seq=location-background&orientation=landscape"
          alt="Location Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{ backgroundColor: 'rgba(20,20,20,0.45)' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif', letterSpacing: '0.05em' }}>
          COME VISIT US
        </h2>
        
        <div className="text-lg text-white/90 mb-12 space-y-2" style={{ lineHeight: '1.6' }}>
          <p className="font-medium">123 Main Street, Downtown</p>
          <p>Monday - Saturday: 10:00 AM - 7:00 PM | Sunday: 11:00 AM - 5:00 PM</p>
        </div>

        <button 
          onClick={handleGetDirections}
          className="inline-flex items-center gap-3 px-12 py-5 rounded-full text-white font-medium text-lg transition-all duration-300 hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          style={{ backgroundColor: '#C67B5C' }}
        >
          Get Directions
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        {/* Map Preview */}
        <div className="mt-12 inline-block rounded-xl overflow-hidden shadow-2xl border-4 border-white/15">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2412648750455!2d-73.98823492346679!3d40.75889497138558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25855c6480299%3A0x55194ec5a1ae072e!2sTimes%20Square!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
            width="320"
            height="240"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Shop Location Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
}